module.exports = __webpack_public_path__ + "media/images/pic/teachers/alicja-suska-1b906a97d83abd748f2b669e15b91076.png";